/**
 * The TextSvgPlaceholder component
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { isServer } from "../../../redux/store";
import canvasBackground from "../../../assets/images/canvas-background.png";

const stageScalingFactors = [
  { match: "(min-width: 1200px)", scale: 1.65 },
  { match: "(max-width: 1200px)", scale: 1.4 },
  { match: "(max-width: 992px)", scale: 1.26 },
  { match: "(max-width: 768px)", scale: 1.05 },
  { match: "(max-width: 576px)", scale: 0.79 },
  { match: "(max-width: 370px)", scale: 0.59 },
];
const placeHolderForLang = {
  en: (
    <div
      id="stage"
      className="svg-preview"
      style={{
        height: "126.614px",
        backgroundImage: `url(${canvasBackground})`,
      }}
    >
      <svg
        id="text-svg"
        height="76.73593629574954"
        version="1.1"
        width="460"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <g transform="translate(0,0) scale(1.7733602310913816,1.7733602310913816)">
          <g
            transform="translate(-0.5859375596046448,42.656253814697266)"
            fill="#000000"
            stroke="none"
          >
            <path
              transform="scale(0.029296875)"
              d="M 625 -716 l380,-740l225,0l-511,944l0,512l-196,0l0,-525l-503,-931l225,0 zM 1412 -551 c0,-160,43,-291,130,-395c87,-104,204,-156,353,-156c150,0,269,52,356,155c87,103,130,235,130,396l0,22c0,161,-43,293,-130,396c-87,103,-205,154,-354,154c-149,0,-267,-52,-354,-155c-87,-103,-131,-234,-131,-395l0,-22zM 1609 -529 c0,115,24,209,72,284c48,75,121,112,216,112c94,0,165,-37,214,-112c49,-75,73,-169,73,-284l0,-22c0,-113,-24,-208,-73,-283c-49,-75,-121,-113,-216,-113c-94,0,-166,38,-214,113c-48,75,-72,170,-72,283l0,22 zM 3309 -160 c-34,58,-78,103,-131,134c-53,31,-115,47,-185,47c-118,0,-210,-38,-276,-113c-66,-75,-99,-193,-99,-352l0,-638l197,0l0,640c0,115,17,195,51,238c34,43,87,65,159,65c70,0,128,-15,174,-43c46,-28,80,-68,103,-120l0,-780l197,0l0,1082l-177,0 zM 4298 -908 l-101,-6c-52,0,-96,12,-132,37c-36,25,-63,59,-82,104l0,773l-197,0l0,-1082l176,0l19,158c31,-56,69,-100,114,-131c45,-31,96,-47,155,-47c15,0,29,2,42,4c13,2,24,4,33,7 zM 6020 -1301 l-468,0l0,1301l-197,0l0,-1301l-467,0l0,-155l1132,0l0,155 zM 6735 21 c-151,0,-271,-51,-360,-151c-89,-100,-133,-230,-133,-390l0,-44c0,-154,45,-282,137,-384c92,-102,201,-154,326,-154c146,0,256,44,331,132c75,88,112,205,112,352l0,123l-702,0l-3,5c2,104,28,189,79,256c51,67,122,101,213,101c67,0,126,-10,176,-29c50,-19,93,-45,130,-78l77,128c-39,38,-90,70,-153,95c-63,25,-140,38,-230,38zM 6705 -947 c-66,0,-122,27,-169,83c-47,56,-75,126,-86,210l2,5l499,0l0,-26c0,-77,-21,-142,-62,-194c-41,-52,-103,-78,-184,-78 zM 7736 -683 l230,-399l230,0l-351,535l361,547l-226,0l-240,-409l-240,409l-228,0l361,-547l-351,-535l227,0 zM 8659 -1343 l0,261l205,0l0,146l-205,0l0,657c0,51,10,86,31,107c21,21,49,31,84,31c11,0,24,-1,38,-4c14,-3,25,-6,36,-10l26,135c-15,12,-36,22,-64,30c-28,8,-57,11,-86,11c-80,0,-144,-25,-191,-73c-47,-48,-71,-124,-71,-227l0,-657l-172,0l0,-146l172,0l0,-261l197,0 z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  ),
  de: (
    <div
      id="stage"
      className="svg-preview"
      style={{
        height: "141.825px",
        backgroundImage: `url(${canvasBackground})`,
      }}
    >
      <svg
        id="text-svg"
        height="85.95438070298154"
        version="1.1"
        width="460"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <g transform="translate(0,0) scale(1.8557300989016952,1.8557300989016952)">
          <g
            transform="translate(-5.273437976837158,45.703128814697266)"
            fill="#000000"
            stroke="none"
          >
            <path
              transform="scale(0.029296875)"
              d="M 180 0 l0,-1456l447,0c191,0,344,59,459,176c115,117,173,268,173,453l0,199c0,186,-58,338,-173,454c-115,116,-268,174,-459,174l-447,0zM 377 -1301 l0,1147l250,0c135,0,241,-44,319,-133c78,-89,116,-202,116,-341l0,-201c0,-137,-38,-250,-116,-339c-78,-89,-184,-133,-319,-133l-250,0 zM 1941 21 c-151,0,-271,-51,-360,-151c-89,-100,-133,-230,-133,-390l0,-44c0,-154,45,-282,137,-384c92,-102,201,-154,326,-154c146,0,256,44,331,132c75,88,112,205,112,352l0,123l-702,0l-3,5c2,104,28,189,79,256c51,67,122,101,213,101c67,0,126,-10,176,-29c50,-19,93,-45,130,-78l77,128c-39,38,-90,70,-153,95c-63,25,-140,38,-230,38zM 1911 -947 c-66,0,-122,27,-169,83c-47,56,-75,126,-86,210l2,5l499,0l0,-26c0,-77,-21,-142,-62,-194c-41,-52,-103,-78,-184,-78 zM 2788 0 l-197,0l0,-1082l197,0l0,1082zM 2788 -1359 l-197,0l0,-201l197,0l0,201 zM 3267 -1082 l14,161c36,-57,81,-101,135,-133c54,-32,117,-48,186,-48c117,0,207,34,271,102c64,68,96,174,96,317l0,683l-197,0l0,-679c0,-95,-18,-163,-56,-203c-38,-40,-96,-60,-173,-60c-57,0,-107,14,-151,41c-44,27,-78,65,-104,112l0,789l-197,0l0,-1082l176,0 zM 5787 -1301 l-468,0l0,1301l-197,0l0,-1301l-467,0l0,-155l1132,0l0,155 zM 6502 21 c-151,0,-271,-51,-360,-151c-89,-100,-133,-230,-133,-390l0,-44c0,-154,45,-282,137,-384c92,-102,201,-154,326,-154c146,0,256,44,331,132c75,88,112,205,112,352l0,123l-702,0l-3,5c2,104,28,189,79,256c51,67,122,101,213,101c67,0,126,-10,176,-29c50,-19,93,-45,130,-78l77,128c-39,38,-90,70,-153,95c-63,25,-140,38,-230,38zM 6472 -947 c-66,0,-122,27,-169,83c-47,56,-75,126,-86,210l2,5l499,0l0,-26c0,-77,-21,-142,-62,-194c-41,-52,-103,-78,-184,-78 zM 7503 -683 l230,-399l230,0l-351,535l361,547l-226,0l-240,-409l-240,409l-228,0l361,-547l-351,-535l227,0 zM 8426 -1343 l0,261l205,0l0,146l-205,0l0,657c0,51,10,86,31,107c21,21,49,31,84,31c11,0,24,-1,38,-4c14,-3,25,-6,36,-10l26,135c-15,12,-36,22,-64,30c-28,8,-57,11,-86,11c-80,0,-144,-25,-191,-73c-47,-48,-71,-124,-71,-227l0,-657l-172,0l0,-146l172,0l0,-261l197,0 z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  ),
  es: (
    <div
      id="stage"
      className="svg-preview"
      style={{
        height: "138.743px",
        backgroundImage: `url(${canvasBackground})`,
      }}
    >
      <svg
        id="text-svg"
        height="84.08663565602853"
        version="1.1"
        width="460"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <g transform="translate(0,0) scale(1.9432341981723005,1.9432341981723005)">
          <g
            transform="translate(-0.9960938096046448,42.656253814697266)"
            fill="#000000"
            stroke="none"
          >
            <path
              transform="scale(0.029296875)"
              d="M 1166 -1301 l-468,0l0,1301l-197,0l0,-1301l-467,0l0,-155l1132,0l0,155 zM 2095 -160 c-34,58,-78,103,-131,134c-53,31,-115,47,-185,47c-118,0,-210,-38,-276,-113c-66,-75,-99,-193,-99,-352l0,-638l197,0l0,640c0,115,17,195,51,238c34,43,87,65,159,65c70,0,128,-15,174,-43c46,-28,80,-68,103,-120l0,-780l197,0l0,1082l-177,0 zM 4104 -1301 l-468,0l0,1301l-197,0l0,-1301l-467,0l0,-155l1132,0l0,155 zM 4819 21 c-151,0,-271,-51,-360,-151c-89,-100,-133,-230,-133,-390l0,-44c0,-154,45,-282,137,-384c92,-102,201,-154,326,-154c146,0,256,44,331,132c75,88,112,205,112,352l0,123l-702,0l-3,5c2,104,28,189,79,256c51,67,122,101,213,101c67,0,126,-10,176,-29c50,-19,93,-45,130,-78l77,128c-39,38,-90,70,-153,95c-63,25,-140,38,-230,38zM 4789 -947 c-66,0,-122,27,-169,83c-47,56,-75,126,-86,210l2,5l499,0l0,-26c0,-77,-21,-142,-62,-194c-41,-52,-103,-78,-184,-78 zM 5820 -683 l230,-399l230,0l-351,535l361,547l-226,0l-240,-409l-240,409l-228,0l361,-547l-351,-535l227,0 zM 6743 -1343 l0,261l205,0l0,146l-205,0l0,657c0,51,10,86,31,107c21,21,49,31,84,31c11,0,24,-1,38,-4c14,-3,25,-6,36,-10l26,135c-15,12,-36,22,-64,30c-28,8,-57,11,-86,11c-80,0,-144,-25,-191,-73c-47,-48,-71,-124,-71,-227l0,-657l-172,0l0,-146l172,0l0,-261l197,0 zM 7145 -551 c0,-160,43,-291,130,-395c87,-104,204,-156,353,-156c150,0,269,52,356,155c87,103,130,235,130,396l0,22c0,161,-43,293,-130,396c-87,103,-205,154,-354,154c-149,0,-267,-52,-354,-155c-87,-103,-131,-234,-131,-395l0,-22zM 7342 -529 c0,115,24,209,72,284c48,75,121,112,216,112c94,0,165,-37,214,-112c49,-75,73,-169,73,-284l0,-22c0,-113,-24,-208,-73,-283c-49,-75,-121,-113,-216,-113c-94,0,-166,38,-214,113c-48,75,-72,170,-72,283l0,22 z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  ),
  it: (
    <div
      id="stage"
      className="svg-preview"
      style={{
        height: "111.678px",
        backgroundImage: `url(${canvasBackground})`,
      }}
    >
      <svg
        id="text-svg"
        height="67.6835727679955"
        version="1.1"
        width="460"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <g transform="translate(0,0) scale(1.4612686655354559,1.4612686655354559)">
          <g
            transform="translate(-5.566406726837158,45.703128814697266)"
            fill="#000000"
            stroke="none"
          >
            <path
              transform="scale(0.029296875)"
              d="M 388 0 l-198,0l0,-1456l198,0l0,1456 zM 935 0 l-197,0l0,-1560l197,0l0,1560 zM 2577 -367 c0,-67,-25,-122,-75,-167c-50,-45,-139,-83,-266,-114c-154,-37,-274,-91,-360,-162c-86,-71,-130,-161,-130,-269c0,-113,47,-208,140,-284c93,-76,213,-114,361,-114c159,0,287,44,381,131c94,87,139,189,136,304l-2,6l-188,0c0,-85,-28,-154,-84,-207c-56,-53,-138,-79,-243,-79c-98,0,-173,22,-225,66c-52,44,-79,103,-79,174c0,63,28,116,85,158c57,42,149,80,276,112c153,38,270,94,350,168c80,74,120,166,120,275c0,117,-48,212,-144,283c-96,71,-221,107,-376,107c-145,0,-274,-39,-386,-118c-112,-79,-165,-184,-162,-316l2,-6l188,0c0,93,34,164,103,213c69,49,154,73,255,73c99,0,178,-21,236,-63c58,-42,87,-99,87,-171 zM 3711 -160 c-34,58,-78,103,-131,134c-53,31,-115,47,-185,47c-118,0,-210,-38,-276,-113c-66,-75,-99,-193,-99,-352l0,-638l197,0l0,640c0,115,17,195,51,238c34,43,87,65,159,65c70,0,128,-15,174,-43c46,-28,80,-68,103,-120l0,-780l197,0l0,1082l-177,0 zM 4142 -551 c0,-160,43,-291,130,-395c87,-104,204,-156,353,-156c150,0,269,52,356,155c87,103,130,235,130,396l0,22c0,161,-43,293,-130,396c-87,103,-205,154,-354,154c-149,0,-267,-52,-354,-155c-87,-103,-131,-234,-131,-395l0,-22zM 4339 -529 c0,115,24,209,72,284c48,75,121,112,216,112c94,0,165,-37,214,-112c49,-75,73,-169,73,-284l0,-22c0,-113,-24,-208,-73,-283c-49,-75,-121,-113,-216,-113c-94,0,-166,38,-214,113c-48,75,-72,170,-72,283l0,22 zM 6884 -1301 l-468,0l0,1301l-197,0l0,-1301l-467,0l0,-155l1132,0l0,155 zM 7599 21 c-151,0,-271,-51,-360,-151c-89,-100,-133,-230,-133,-390l0,-44c0,-154,45,-282,137,-384c92,-102,201,-154,326,-154c146,0,256,44,331,132c75,88,112,205,112,352l0,123l-702,0l-3,5c2,104,28,189,79,256c51,67,122,101,213,101c67,0,126,-10,176,-29c50,-19,93,-45,130,-78l77,128c-39,38,-90,70,-153,95c-63,25,-140,38,-230,38zM 7569 -947 c-66,0,-122,27,-169,83c-47,56,-75,126,-86,210l2,5l499,0l0,-26c0,-77,-21,-142,-62,-194c-41,-52,-103,-78,-184,-78 zM 8862 -287 c0,-43,-17,-79,-50,-107c-33,-28,-95,-52,-187,-73c-131,-29,-231,-68,-297,-117c-66,-49,-99,-115,-99,-200c0,-88,37,-163,112,-225c75,-62,172,-93,292,-93c126,0,227,32,301,97c74,65,109,143,106,236l-2,6l-188,0c0,-47,-20,-89,-60,-127c-40,-38,-92,-57,-157,-57c-70,0,-122,15,-156,46c-34,31,-51,68,-51,111c0,43,15,76,45,101c30,25,91,47,183,66c137,29,238,69,305,119c67,50,100,118,100,203c0,96,-39,174,-117,233c-78,59,-179,89,-304,89c-138,0,-247,-35,-326,-105c-79,-70,-117,-152,-113,-245l2,-6l188,0c3,70,29,121,78,153c49,32,106,49,171,49c70,0,124,-15,164,-43c40,-28,60,-65,60,-111 zM 9564 -1343 l0,261l205,0l0,146l-205,0l0,657c0,51,10,86,31,107c21,21,49,31,84,31c11,0,24,-1,38,-4c14,-3,25,-6,36,-10l26,135c-15,12,-36,22,-64,30c-28,8,-57,11,-86,11c-80,0,-144,-25,-191,-73c-47,-48,-71,-124,-71,-227l0,-657l-172,0l0,-146l172,0l0,-261l197,0 zM 9966 -551 c0,-160,43,-291,130,-395c87,-104,204,-156,353,-156c150,0,269,52,356,155c87,103,130,235,130,396l0,22c0,161,-43,293,-130,396c-87,103,-205,154,-354,154c-149,0,-267,-52,-354,-155c-87,-103,-131,-234,-131,-395l0,-22zM 10163 -529 c0,115,24,209,72,284c48,75,121,112,216,112c94,0,165,-37,214,-112c49,-75,73,-169,73,-284l0,-22c0,-113,-24,-208,-73,-283c-49,-75,-121,-113,-216,-113c-94,0,-166,38,-214,113c-48,75,-72,170,-72,283l0,22 z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  ),
};
/**
 * Stateless react component to render the TextSvgPlaceholder page
 * @param {Object} props the props passed to the page.
 */
class TextSvgPlaceholder extends Component {
  updateStageHeight() {
    const { size } = this.props;
    let height = size.previewHeight;
    if (!isServer) {
      stageScalingFactors.forEach((factor) => {
        if (window.matchMedia(factor.match).matches) {
          height = size.previewHeight * factor.scale;
        }
      });
    }

    return height;
  }

  render() {
    const { language } = this.props;

    // const height = this.updateStageHeight()
    return <div>{placeHolderForLang[language]}</div>;
  }
}

TextSvgPlaceholder.contextTypes = {
  t: PropTypes.func,
};
export default TextSvgPlaceholder;
